// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__164br","footer":"ModalError_footer__3jfKm"};